export default class PolicyData {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "";
  }

  /**
   * Updates policy data and carries submit intent via URL query parameter.
   */
  updatePolicyData(healthPlanKey, policyKey, payload, isSubmit = false) {
    return this.client.patch(
      `/healthplan/${healthPlanKey}/policy/${policyKey}`,
      payload,
      {
        params: { isSubmit },
      }
    );
  }

  getPolicyData(healthPlanKey, policyKey) {
    return this.client.get(`/policy/getPolicyData`, {
      params: { healthPlanKey, policyKey },
    });
  }

  getPolicyChangeControlData(healthPlanKey, policyKey) {
    return this.client.get(`/policy/getPolicyChangeControlData`, {
      params: { healthPlanKey, policyKey },
    });
  }

  getPolicyBusinesRuleNames(rules) {
    return this.client.post(
      `/apeaRuleRetrieval/retrievePolicyBusinessRules`,
      rules
    );
  }

  getPolicyRuleUnits(healthPlanKey, policyKey, tabSuffix) {
    return this.client.get(
      `/healthplan/${healthPlanKey}/policy/${policyKey}/rule-unit/${tabSuffix}`
    );
  }

  updatePolicyRuleUnits(healthPlanKey, policyKey, tabSuffix, payload) {
    return this.client.post(`/rule-unit/${tabSuffix}`, payload);
  }

  validateRuleUnit(policyKey, payload) {
    return this.client.put(
      `/policy/${policyKey}/rule-unit/pdm/validate`,
      payload
    );
  }
  /**
   * Validates rule units for the requested policy and tab suffix.
   */
  validatePolicyRuleUnits(policyKey, tabSuffix, payload) {
    return this.client.put(
      `/policy/${policyKey}/rule-unit/${tabSuffix}/validate`,
      payload
    );
  }
}
